
import { create } from 'zustand'
import { ICustomerDTO } from '../dtos/user-dto'
import { config } from 'config'

type IActionsProps = {
  setCustomer: (customer: ICustomerDTO | undefined) => void
  checkIfHaveSession: () => void
  setSessionId: (value: string) => void
}

type IStoreProps = {
  customer: ICustomerDTO | undefined
  sessionId: string
  actions: IActionsProps
}

export const ZuAuthStore = create<IStoreProps>((set) => ({
  customer: undefined,
  sessionId: '',
  actions: {
    setCustomer: (value) => {
      localStorage.setItem(`@${config.appAgent}:customer`, JSON.stringify(value))
      return set(() => ({ customer: value }))
    },
    checkIfHaveSession: () => {
      const data = localStorage.getItem(`@${config.appAgent}:customer`)
      return set(() => ({ customer: data ? JSON.parse(data) : undefined }))
    },
    setSessionId: (value) => {
      return set(() => ({ sessionId: value }))
    },
  },
}))
